import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
} from '@simplewebauthn/browser'

export function isWebAuthnSupported() {
  return browserSupportsWebAuthn()
}

export function getDefaultDeviceName() {
  const ua = navigator.userAgent
  if (/iPhone|iPad|iPod/i.test(ua)) return 'iPhone / iPad'
  if (/Android/i.test(ua)) return 'Android'
  if (/Mac/i.test(ua)) return 'Mac'
  if (/Windows/i.test(ua)) return 'Windows'
  return 'Dispositivo'
}

export async function loginWithPasskey({ client, user, apiUrl }) {
  const optionsRes = await fetch(`${apiUrl}/login/webauthn/options`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      client,
      user: user.toLowerCase(),
    }),
  })

  const optionsData = await optionsRes.json()
  if (optionsData.status !== 'ok') {
    throw new Error(optionsData.msg || 'No se pudo iniciar el login biometrico')
  }

  const credential = await startAuthentication({ optionsJSON: optionsData.body })

  const loginRes = await fetch(`${apiUrl}/login/webauthn`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      client,
      user: user.toLowerCase(),
      credential,
    }),
  })

  const loginData = await loginRes.json()
  if (loginData.status !== 'ok') {
    throw new Error(loginData.msg || 'No se pudo verificar la biometria')
  }

  return loginData
}

export async function registerPasskey({ apiUrl, token, deviceName }) {
  const optionsRes = await fetch(`${apiUrl}/webauthn/register/options`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token,
    },
  })

  const optionsData = await optionsRes.json()
  if (optionsData.status !== 'ok') {
    throw new Error(optionsData.msg || 'No se pudo iniciar el registro biometrico')
  }

  const credential = await startRegistration({ optionsJSON: optionsData.body })

  const registerRes = await fetch(`${apiUrl}/webauthn/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token,
    },
    body: JSON.stringify({
      credential,
      deviceName: deviceName || getDefaultDeviceName(),
    }),
  })

  const registerData = await registerRes.json()
  if (registerData.status !== 'ok') {
    throw new Error(registerData.msg || 'No se pudo registrar la biometria')
  }

  return registerData
}

export async function listPasskeys({ apiUrl, token }) {
  const res = await fetch(`${apiUrl}/webauthn/credentials`, {
    method: 'GET',
    headers: { token },
  })

  const data = await res.json()
  if (data.status !== 'ok') {
    throw new Error(data.msg || 'No se pudieron cargar los dispositivos biometricos')
  }

  return data.body || []
}

export async function deletePasskey({ apiUrl, token, credentialId }) {
  const res = await fetch(`${apiUrl}/webauthn/credentials/${encodeURIComponent(credentialId)}`, {
    method: 'DELETE',
    headers: { token },
  })

  const data = await res.json()
  if (data.status !== 'ok') {
    throw new Error(data.msg || 'No se pudo eliminar el dispositivo biometrico')
  }

  return data
}
